import { LOCALISE_LANGUAGE_FIELD_NAME } from '@pkg/config/sanity/constants';
import { WWW_AUDIENCE_FILTER } from '@pkg/config/sanity/audience';
import { slugWithParents } from '@pkg/sanity-utils/slugWithParents';

export function listingByFilter() {
  const type = '_type == $type';
  const locale = `(!defined($locale) || ${LOCALISE_LANGUAGE_FIELD_NAME} == $locale)`;
  const audience = WWW_AUDIENCE_FILTER;
  // const postsPerPage = '[0...$postsPerPage]';
  const slice = '[$sliceStart...$sliceEnd]';
  // const createdAt = '(defined($createdAt) && _createdAt < $createdAt)';
  const filter = '(!defined($activeFilter) || references(*[_type==$taxonomy && (slug.current in $activeFilter)]._id))';
  const countFilter = `*[${type} && ${locale} && ${audience} && ${filter}]`;
  const postFilter = `*[${type} && ${locale} && ${audience} && ${filter}]`;

  return groq`{
    "totalPosts": count(${countFilter}),
    "posts": ${postFilter} | order(publishedAt desc) ${slice} {
    _id,
    _createdAt,
    publishedAt,
    updatedAt,
    language,
    title,
    pretitle,
    image,
    excerpt,
    migrated,
    categories[]->{
      title,
      "slug": slug.current,
    },
    "content": pt::text(content),
    ${slugWithParents},
    "file": file.asset->,
    url
    }
  }`;
}
